import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import Drawer from '@mui/material/Drawer';

import MovilMenu from './MovilMenu/MovilMenu';
import UserOptionsHeader from '../../components/UserOptionsHeader/UserOptionsHeader';
import MenuHeader from 'uI/Header/MenuHeader/MenuHeader';

import classes from './Header.module.css';

const Header = () => {
  const userInfo = useSelector(state => state.userInfo);
  const [state, setState] = useState(false);

  useEffect(() => {
    if (userInfo.udcHost) {
      var link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href =
        'https://d1g6c01s9ssd7h.cloudfront.net/img/favIco_UDC.ico';
    }
  }, [userInfo.udcHost]);

  const toggleDrawer = () => event => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }
    setState(!state);
  };

  return (
    <AppBar position="static" className={classes.headerContainer}>
      <Toolbar className={classes.header}>
        <IconButton
          onClick={toggleDrawer(state, true)}
          size="large"
          edge="start"
          color="inherit"
          aria-label="menu"
          sx={{ mr: 2 }}
          className={classes.menuIcon}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          anchor="left"
          open={state}
          onClose={toggleDrawer(state, false)}
        >
          <MovilMenu
            closeMenu={toggleDrawer(state, false)}
            udcHost={userInfo.udcHost}
          />
        </Drawer>
        {userInfo.udcHost ? (
          <figure className={classes.udcImage}>
            <img
              src="https://d1g6c01s9ssd7h.cloudfront.net/img/LogoUDC_n.png"
              alt="Mayahii image"
              className={classes.img}
            />
          </figure>
        ) : (
          <figure className={classes.mayahiiImage}>
            <img
              src="https://s3.amazonaws.com/mayahii-frontend/img/logo_mayahiiNEw.png"
              alt="Mayahii image"
              className={classes.img}
            />
          </figure>
        )}

        <MenuHeader udcHost={userInfo.udcHost} />
        <UserOptionsHeader />
        {/* <UserOptionsHeader /> */}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
